import { useDeleteAlertRuleMutation } from "@entities/alert-rule";

import { Button } from "@shared/ui";

export interface AlertRuleDeleteButtonProps {
  communityId: string | null;
  ruleId: string;
}

export function AlertRuleDeleteButton({
  communityId,
  ruleId,
}: AlertRuleDeleteButtonProps) {
  const remove = useDeleteAlertRuleMutation(communityId);
  const disabled = communityId === null || remove.isPending;
  return (
    <Button
      type="button"
      size="sm"
      variant="ghost"
      disabled={disabled}
      onClick={() => {
        remove.mutate(ruleId);
      }}
      aria-label="Delete alert rule"
    >
      Delete
    </Button>
  );
}
